"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuComponent = exports.Menu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@headlessui/react");
var _useOverlay = require("../Overlay/useOverlay");
var _MenuItems = require("./MenuItems");
var _MenuButton = require("./MenuButton");
var _MenuItem = require("./MenuItem");
var _MenuContext = require("./MenuContext");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MenuComponent = _ref => {
  let {
    children,
    floating = true,
    placement = "bottom"
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  const overlayData = (0, _useOverlay.useOverlay)({
    open,
    placement,
    onOpenChange: setOpen,
    role: "menu"
  });
  return /*#__PURE__*/_react.default.createElement(_react2.Menu, null, _ref2 => {
    let {
      open,
      close
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_MenuContext.MenuContext.Provider, {
      value: {
        overlayData,
        floating,
        open
      }
    }, typeof children === "function" ? children({
      open,
      close
    }) : children);
  });
};
exports.MenuComponent = MenuComponent;
MenuComponent.displayName = "Menu";
const Menu = Object.assign(MenuComponent, {
  Items: _MenuItems.MenuItems,
  Item: _MenuItem.MenuItem,
  Button: _MenuButton.MenuButton
});
exports.Menu = Menu;